import { Modal } from 'components/Modal'
import { getWorkstreamDetailModalData } from 'constants/WorkingModePathwaysDetailModals'

import { DetailSubsectionBlock, OutputText, SessionToolsSection, StepsList, TeamSection } from './DetailModalParts'
import { ModalHeader } from './ModalHeader'

interface WorkstreamDetailModalProps {
  isOpen: boolean
  onClose: () => void
  id: string
}

export const WorkstreamDetailModal = ({ isOpen, onClose, id }: WorkstreamDetailModalProps) => {
  const data = getWorkstreamDetailModalData(id)
  if (!data) return null

  const column1Style = data.color === 'gradient' ? undefined : { backgroundColor: data.color }

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="workstream-detail-modal">
      <ModalHeader title={data.title} onClose={onClose} />

      <div className="workstream-detail-columns">
        <div
          className={`workstream-detail-column-1 ${data.color === 'gradient' ? 'pathway-detail-gradient' : ''}`}
          style={column1Style}
        >
          <p className="subtitle-xl w-full">{data.column1Heading}</p>
          {data.subsections.map((subsection, index) => (
            <div key={subsection.label} className="flex flex-col gap-4 items-start w-full">
              <DetailSubsectionBlock subsection={subsection} />
              {index < data.subsections.length - 1 && <div className="pathway-divider" />}
            </div>
          ))}
        </div>

        <div className="workstream-detail-column">
          {data.team ? (
            <TeamSection team={data.team} bgColor={data.bgColor ? data.bgColor : ''} />
          ) : (
            <div
              className="flex flex-col gap-4 items-start p-4 self-stretch rounded-2xl w-full flex-[1_0_0]"
              style={{ backgroundColor: data.bgColor }}
            >
              <p className="title-xs">Team</p>
              <p className="body-xs w-full">{data.teamParagraph}</p>
              {data.teamNote && <p className="body-xs font-bold w-full">{data.teamNote}</p>}
            </div>
          )}
          <div className="pathway-divider" />
          <SessionToolsSection bgColor={data.bgColor ?? ''} imgUrl={data.imgUrl ?? ''} />
          <div className="pathway-divider" />
          <div
            className="flex flex-col gap-4 items-start p-4 self-stretch rounded-2xl w-full flex-[1_0_0]"
            style={{ backgroundColor: data.bgColor }}
          >
            <p className="subtitle-xl">Output</p>
            <OutputText text={data.outputText} boldText={data.outputTextBold} />
          </div>
        </div>

        <div className="workstream-detail-column p-4" style={{ backgroundColor: data.bgColor }}>
          <StepsList steps={data.steps} />
        </div>
      </div>
    </Modal>
  )
}
